import { render, staticRenderFns } from "./WPBaseMultiSwitchItem.vue?vue&type=template&id=60237af3"
import script from "./WPBaseMultiSwitchItem.vue?vue&type=script&lang=ts"
export * from "./WPBaseMultiSwitchItem.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseMultiSwitchItem.vue?vue&type=style&index=0&id=60237af3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports